import { render, staticRenderFns } from "./SettingsRostering.vue?vue&type=template&id=4ec370f0&"
import script from "./SettingsRostering.vue?vue&type=script&lang=js&"
export * from "./SettingsRostering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports